import React from "react";

const PlaceholderIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      {...props}
    >
      <path
        d="M20.7133 16.3332C22.1623 16.3332 23.337 17.5079 23.337 18.9569V20.0285C23.337 20.6974 23.1279 21.3496 22.739 21.8938C20.9354 24.4176 17.9904 25.6679 14.0001 25.6679C10.009 25.6679 7.06551 24.4171 5.26633 21.892C4.87904 21.3484 4.6709 20.6976 4.6709 20.0302V18.9569C4.6709 17.5079 5.84556 16.3332 7.29459 16.3332H20.7133ZM14.0001 2.33871C17.2218 2.33871 19.8334 4.95039 19.8334 8.17205C19.8334 11.3937 17.2218 14.0054 14.0001 14.0054C10.7784 14.0054 8.16677 11.3937 8.16677 8.17205C8.16677 4.95039 10.7784 2.33871 14.0001 2.33871Z"
        fill="white"
      />
    </svg>
  );
};

export default PlaceholderIcon;
